import React from 'react';
import { Carousel } from "react-bootstrap";
import classnames from 'classnames';
import NewFeaturedProductInner from './new-featured-product-inner';

import './new-feature.css';
import './card.css';

class NewFeaturedProductCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {
        let { products } = this.props;
        return (
            <Carousel indicators={false} controls={products.length > 1}>
                {products.map((product, key) => (
                    <Carousel.Item key={key}>
                        <div className={classnames('carousel-image', 'featured-product-carousel-info')}
                            style={{
                                background:
                                    `no-repeat
                                     center
                                     url(${product.attributes.links['marketing-image']})`,
                                backgroundSize: 'cover'
                            }}>
                            <NewFeaturedProductInner product={product} handleConfirmation={this.props.handleConfirmation} />
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        )
    }
}

export default NewFeaturedProductCard;


// WEBPACK FOOTER //
// ./src/components/new-order/new-featured-product-card.jsx